import { type FieldContentsData } from 'javascripts/shared-types';
import Field from '../../Field';
import { promotedRecordQuery } from './PromotedRecordQuery';

export class PromotedRecordName extends Field {
  static subqueriesForModel() {
    return {
      promotable: promotedRecordQuery(),
    };
  }

  get title() {
    return 'Promoted to record name';
  }

  exampleContents(): FieldContentsData {
    return { text: 'Example feature' };
  }

  contentsForRecord(record): FieldContentsData {
    if (record?.promotable) {
      return {
        text: record.promotable.name,
      };
    }

    return {};
  }
}
